// This file was auto-generated by Fern from our API Definition.
const AuthSchemesRequirementValues = {
    All: "ALL",
    Any: "ANY",
    EndpointSecurity: "ENDPOINT_SECURITY",
};
export const AuthSchemesRequirement = Object.assign(Object.assign({}, AuthSchemesRequirementValues), { _visit: (value, visitor) => {
        switch (value) {
            case AuthSchemesRequirement.All:
                return visitor.all();
            case AuthSchemesRequirement.Any:
                return visitor.any();
            case AuthSchemesRequirement.EndpointSecurity:
                return visitor.endpointSecurity();
            default:
                return visitor._other();
        }
    } });
